@if (roleEntites.length > 1) {
  <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.VIEWING_COMPANY' | translate
  }}</span>
  <select title="roleEntite" id="roleEntite" class="w-full p-2 border rounded" [(ngModel)]="entiteIdSelectionne"
    (ngModelChange)="onEntityChange()">
    <option [ngValue]="null">{{ 'USERS_MANAGEMENT.SELECT_COMPANY' | translate }}</option>
    @for (roleEntite of roleEntites; track roleEntite) {
      <option [value]="roleEntite.id" [disabled]="!roleEntite.estActif">
        {{ roleEntite.nom }} @if (!roleEntite.estActif) {
        <span class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})
        </span>
      }
    </option>
  }
</select>
}

@if (roleEntites.length === 1) {
  <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.VIEWING_COMPANY_SINGLE' | translate
  }}: {{ roleEntites[0].nom }}</span>
}

<div class="mb-4 mt-2">
  <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.TAGS' | translate }}</span>
  <select #etiquetteSelect title="TAGS" id="etiquettes" (change)="onEtiquetteSelected($event, etiquetteSelect)"
    class="w-full p-2 border rounded">
    <option value="">{{ 'USERS_MANAGEMENT.SELECT_TAG' | translate }}</option>
    @for (etiquette of availableEtiquettes; track etiquette) {
      <option [value]="etiquette.etiquetteId">
        {{ etiquetteService.getNomLocalise(etiquette.locales) }}
      </option>
    }
  </select>

  @if (selectedEtiquettes.length > 0) {
    <div class="mt-3">
      <div class="titre4Modal">{{ 'USERS_MANAGEMENT.SELECTED_TAGS' | translate }}:</div>
      <ul class="list-disc list-inside">
        @for (etiquette of selectedEtiquettes; track etiquette) {
          <li>
            {{ etiquetteService.getNomLocalise(etiquette.locales) }}
            <button (click)="removeSelectedEtiquette(etiquette.etiquetteId)" class="ml-2 text-rougeNovo">
              {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>

<div class="mb-4 mt-4">
  <label for="email" class="block text-sm font-medium  mb-1">
    {{ 'USERS_MANAGEMENT.EMAIL_ADDRESSES' | translate }} {{ limiterA5lignes ? ('USERS_MANAGEMENT.LIMITED_TO_5_LINES'
    | translate) : '' }}
  </label>
  <textarea id="email" name="email" [(ngModel)]="emailInput" (ngModelChange)="validateEmails()" [attr.rows]="5"
    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
  placeholder="{{ 'USERS_MANAGEMENT.EMAIL_PLACEHOLDER' | translate }}" (input)="limitLines($event)"></textarea>
  @if (emailInvalid) {
    <div class="text-rougeNovo text-sm mt-1">
      {{ 'USERS_MANAGEMENT.INVALID_EMAIL_MESSAGE' | translate }}
    </div>
  }
</div>
